var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"popup-tip"},[_c('p',{staticClass:"popup-tip__title"},[_vm._v("弹窗公告")]),_c('p',{staticClass:"popup-tip__subtitle"},[_vm._v(" 占位，可点击右侧弹窗状态打开预览此模块。 ")])])])
}]

export { render, staticRenderFns }